import React from "react";
import styles from "./ChangeLog.module.scss";
import version from "../../utils/versionChangeLog.json";
import service from "../../assets/service.svg";
import plus from "../../assets/circle-plus.svg";
import rocket from "../../assets/gear.svg";

const versionNumber = (version.at(0)?.major ?? 0) + "." + (version.at(0)?.minor ?? 0);
const iVersion = version.at(0);

const ChangeLog: React.FC = () => {
  function selectIcon(value: number) {
    if (value == 1) {
      return <img src={plus}></img>;
    } else {
      return <img src={service}></img>;
    }
  }

  return (
    <div className={styles.mainWindowToRow}>
      <div className={styles.mainWindowIcon}>
        <img src={rocket}></img>
      </div>
      <div>
        <div>
          <div className={styles.notesDateDiv}>{iVersion?.postDate}</div>
          <h1 className={styles.notesTitleH1}>
            Version {versionNumber} &#34;{iVersion?.versionNickname}&#34; is out!
          </h1>
        </div>
        <div className={styles.notesDescriptionDiv}>{iVersion?.description}</div>
        {iVersion?.featuresList.map(feature => {
          return (
            <div key={feature?.id} className={styles.featureMainDiv}>
              <div className={styles.featureIcon}>{selectIcon(feature?.type)}</div>
              <div className={styles.featureDiv}>{feature?.text}</div>
            </div>
          );
        })}
        <div className={styles.notesFooterDiv}>{iVersion?.footerNote}</div>
      </div>
    </div>
  );
};

export default ChangeLog;
